(function() {
    'use strict';
    
a3_cabin_reports.controller('FlightDetailCtrl', FlightDetailCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name FlightDetailCtrl
    * @description 
    *  Manages the Flight Detail Modal View
    * @ngInject
    */
function FlightDetailCtrl($scope, $uibModalInstance, ModalDialogResultFactory, CabinReportLocalEditFactory, AircraftTypeFactory, fd) {
		var result = ModalDialogResultFactory.createNew();

		result.Object = CabinReportLocalEditFactory.fromObject(fd);

		var reportAircraftTypes = new Array();
		var allAircraftTypes = AircraftTypeFactory.getAircraftTypesFromStorage();
		for (var c = 0; c < allAircraftTypes.length; c++) {

			reportAircraftTypes.push(allAircraftTypes[c].Code);
		}

		$scope.aircraftTypes = reportAircraftTypes;
		$scope.fd = result.Object;

		$scope.ok = ok;
		$scope.cancel = cancel;
    
                
        /**
         * Close modal after u check position
         * @memberof FlightDetailCtrl
         */
        function ok() {
			if ((result.Object.AcType == null) || (result.Object.AcType == ''))
				result.Object.AcType = '-';
			$uibModalInstance.close(result);
		}
        
         /**
         * Close Modal
         * @memberof FlightDetailCtrl
         */
        function cancel() {
			$uibModalInstance.close(null);
		}

	}
    
})();